import { useEffect, useState } from 'react'
import { useNavigate } from "react-router-dom";
import PageMenu from 'components/blocks/PageMenu/PageMenu'
import IconArrowGray from "../../../../img/icons/svg/botones/flecha-big-gris.svg";
import { useParams } from 'react-router-dom';
import Loader from 'components/blocks/Loader/Loader';
import useDecode from 'hooks/useDecode';
import SolicitudPagoDirecto from './SolicitudPagoDirecto';
import useGetSolicitudPagoDirectoByID from 'services/record/SolicitudPagoDirecto/useGetSolicitudPagoDirectoByID';
interface Params {
    idprestacion: string;
    idform: string;
}


const HistorialSolicitudPagoDirecto = ({ expedienteId = null, origen = null }) => {
    const decoded = useDecode("token");
    const userId = decoded?.extension_id;
    const [data, setData] = useState(null);
    const navigate = useNavigate()
    const { dataGetSolicitudPagoDirectoByID, errorGetSolicitudPagoDirectoByID, getSolicitudPagoDirectoByID, loadingGetSolicitudPagoDirectoByID, successGetSolicitudPagoDirectoByID } = useGetSolicitudPagoDirectoByID();
    const { idprestacion, idform } = useParams<Record<string, string>>();
    const expedienteIdByOrigen = Number(origen) === 1 ? (expedienteId ?? null) : null;
    const dataUserWithExpedienteByOrigen = (payload) => (expedienteIdByOrigen !== null && expedienteIdByOrigen !== undefined ? { ...payload, ExpedienteId: expedienteIdByOrigen } : payload);


    useEffect(() => {
        const actualUrl = window.location.href;
        if (!actualUrl.includes('/mis-gestiones/formularios')) {
            const prestacionId = idprestacion?.split('_')[1] || idprestacion;
            const formId = idform;

            if (userId && prestacionId && formId) {
                getSolicitudPagoDirectoByID(userId, prestacionId, formId, (payload) => setData(dataUserWithExpedienteByOrigen(payload)));
            }
        }
    }, [expedienteIdByOrigen, idform, idprestacion, userId]);

    return (
        <div>
            <PageMenu title={'Solicitud de Pago Directo Incapacidad Temporal'}>

                <div className="btns-header-container">
                    <button aria-label="Volver atrás" onClick={() => navigate(-1)}>
                        <img src={IconArrowGray} alt="" />
                    </button>
                </div>
            </PageMenu>


            {
                loadingGetSolicitudPagoDirectoByID ?
                    <Loader activeLoader={true} label="Cargando Formulario"></Loader>
                    :
                    <SolicitudPagoDirecto dataUser={data} info={false} />
            }




        </div>
    )
}

export default HistorialSolicitudPagoDirecto